import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() totalElements: number | undefined
  @Input() pageSize: number = 10
  @Input() padding: boolean = true
  total: number | undefined
  pagesTotal: number[] = []
  pages: number[] = []
  page: number = 1
  @Output() selectPage: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }
  
  ngOnChanges() {
    this.load()
  }

  load(){
    this.pagesTotal = []
    this.pages = []
    this.page = 1
   // @ts-ignore
    this.total = this.totalElements / this.pageSize
    for (let i = 0; i < this.total; i++) {
      this.pagesTotal.push(i + 1)
    }
    this.reduce(5, 3)
  }

  reduce(size: number, position: number) {
    this.pages = this.pagesTotal.filter(el => {
      return (position - 1 <= el && el <= position + 1) || el == 1 || el == this.pagesTotal.length
    })
  }

  getPosition(page: number): number {
    let radio = 1
    let position = 3
    if (page == 1 || page == 2) {
      position = 3
    } else {
      if (page == this.pagesTotal.length || page == this.pagesTotal.length - 1) {
        position = this.pagesTotal.length - 2
      } else {
        position = page
      }
    }
    return position
  }

  changePage(page: number) {
    this.page = page
    this.selectPage.emit(this.page)
    this.reduce(5, this.getPosition(page))
  }
  get startItem(): number {
    return (this.page - 1) * this.pageSize + 1;
  }
  
  get endItem(): number {
    return Math.min(this.page * this.pageSize, this.totalElements ?? 0);
  }
  
  next() {
    if (this.page >= 1 && this.page < this.pagesTotal.length) {
      this.changePage(this.page + 1)
    }
  }

  prev() {
    if (this.page > 1 && this.page <= this.pagesTotal.length) {
      this.changePage(this.page - 1)
    }
  }

  prevBool(): boolean {
    return this.page > 1 && this.page <= this.pagesTotal.length
  }

  nextBool(): boolean {
    return (this.page >= 1 && this.page < this.pagesTotal.length)
  }

}
